import { HOURLY, MONTHLY, ANNUAL } from '@/lib/constants/expenseAmountTypes'
import { PRE_GP } from '@/lib/constants/expensesTypes'

export function getHourlyExpenseDeduction (expenseAmountType, amount, workedHoursAverage) {
  switch (expenseAmountType) {
    case HOURLY:
      return amount
    case MONTHLY:
      return amount / workedHoursAverage
    case ANNUAL:
      return (amount / 12) / workedHoursAverage
    default:
      return 0
  }
}

export function getMonthlyExpenseDeduction (expenseAmountType, amount, workedHoursAverage) {
  switch (expenseAmountType) {
    case HOURLY:
      return amount * workedHoursAverage
    case MONTHLY:
      return amount
    case ANNUAL:
      return amount / 12
    default:
      return 0
  }
}

export function getAnnualExpenseDeduction (expenseAmountType, amount, workedHoursAverage) {
  switch (expenseAmountType) {
    case HOURLY:
      return amount * workedHoursAverage * 12
    case MONTHLY:
      return amount * 12
    case ANNUAL:
      return amount
    default:
      return 0
  }
}

export function convertExpenseDeduction (amount, currentExpenseAmountType, desiredExpenseAmountType, workedHoursAverage) {
  switch (desiredExpenseAmountType) {
    case HOURLY:
      return getHourlyExpenseDeduction(currentExpenseAmountType, amount, workedHoursAverage)
    case MONTHLY:
      return getMonthlyExpenseDeduction(currentExpenseAmountType, amount, workedHoursAverage)
    case ANNUAL:
      return getAnnualExpenseDeduction(currentExpenseAmountType, amount, workedHoursAverage)
  }
}

export function getExpensesDeduction (expenses, desiredExpenseAmountType, workedHoursAverage) {
  let totalExpenseDeduction = 0
  for (const expense of expenses) {
    if (expense.expenseTypeId === PRE_GP) {
      totalExpenseDeduction += convertExpenseDeduction(expense.amount, expense.expenseAmountTypeId, desiredExpenseAmountType, workedHoursAverage)
    }
  }
  return totalExpenseDeduction
}
